export const MinimumLoanDataOfSetUserDetailsMapper = {
  reverseMap(participant, borrowerDocumentation) {
    const userDetails = participant.onboardingDetails?.user_details;
    const documentIdDetails = userDetails?.document_id;
    const entranceDate = userDetails.main_residence_details.entrance_date;
    return {
      main_residence_details: {
        address: userDetails.main_residence_details.address,
        ownership_type:
          userDetails.main_residence_details.ownership_details.ownership_type,
        property_type:
          userDetails.main_residence_details.ownership_details.property_type,
        mortgage: userDetails.main_residence_details.ownership_details.mortgage,
        home_expenses: userDetails.main_residence_details.home_expenses,
        ...(entranceDate && { entrance_date: entranceDate }),
      },
      familiar_situation_details: {
        marital_status:
          userDetails.familiar_situation_details.marital_situation
            .marital_status,
        marital_regime:
          userDetails.familiar_situation_details.marital_situation
            .marital_regime,
        child_support_number:
          userDetails.familiar_situation_details.child_support_number,
      },
      complement_nie_eu:
        documentIdDetails.document_type === "nie_eu"
          ? {
              nationality: documentIdDetails.nationality,
              gender: documentIdDetails.gender,
              passport_image: borrowerDocumentation.find(
                (document) => document.type === "passport"
              ).data,
            }
          : null,
    };
  },
};
